export function formatNumberWithCommas(number, fixed = false) {
    const fixedNumber = fixed ? Number(number).toFixed(2) : Number(number);
    if (number >= 1000) {
        return fixedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return fixedNumber;
}
